import { Button, CircularProgress } from '@material-ui/core';
import React, { useState } from 'react'
import { auth } from '../Backend/firebase/firebase';
import CustomAlert from './CustomAlert';
import { sleep } from './Models/CommonFunc';
import { Helmet } from 'react-helmet';

function ForgotPassword() {
    const [openNotify, setOpenNotify] = useState(false);
    const [notificationMessage, setNotificationMessage] = useState('');
    const [alertType, setAlertType] = useState('');
    const [forgotPasswordEmail, setForgotPasswordEmail] = useState('');
    const [isForgotLoading, setIsForgotLoading] = useState(false);

    const handleForgotPassword = async () => {
        setIsForgotLoading(true);
        if (forgotPasswordEmail) {
            await auth.sendPasswordResetEmail(forgotPasswordEmail)
                .then(async function () {
                    setNotificationMessage('Password reset link has sent to this email address.');
                    setOpenNotify(true);
                    setAlertType('success');
                    setIsForgotLoading(false);
                    await sleep(2000);
                    window.location.reload(true);
                }).catch((err) => {
                    setNotificationMessage(err.message);
                    setOpenNotify(true);
                    setAlertType('error');
                    setIsForgotLoading(false);
                });
        } else {
            setNotificationMessage('Please enter the email first!');
            setOpenNotify(true);
            setAlertType('error');
            setIsForgotLoading(false);
        }
    }

    return (
        <>
            <div className="row">
                <Helmet>
                    <meta name="description" content="Forgot password page.." />
                    <title>Forgot Password | Kaipsool Pharmatech</title>
                </Helmet>
                <div className="col-md-12 mb-3">
                    <div className="form-group">
                        <input type="email" name="email" placeholder="Email Address"
                            className="form-control login__textbox" autoComplete="off"
                            value={forgotPasswordEmail} onChange={(e) => setForgotPasswordEmail(e.target.value)} />
                    </div>
                </div>
                <div className="col-md-12 text-center">
                    <Button type="submit" variant="contained" color="primary" size="small"
                        className="login__btn" onClick={handleForgotPassword}>
                        {isForgotLoading ? <CircularProgress size={18} color="white" /> : 'Forgot Password'}
                    </Button>
                </div>
            </div>

            <CustomAlert setOpenNotify={setOpenNotify} openNotify={openNotify} messageType={alertType || 'error'}
                notificationMessage={notificationMessage} />
        </>
    )
}

export default ForgotPassword
